export default {
      id: "arr-usage",
      viewBox: "0 0 8 15",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#arr",
      toString: function () {
        return this.url;
      }
    }